import { render, staticRenderFns } from "./PassengerListItem.vue?vue&type=template&id=30339b5a&scoped=true"
import script from "./PassengerListItem.vue?vue&type=script&lang=ts"
export * from "./PassengerListItem.vue?vue&type=script&lang=ts"
import style0 from "./PassengerListItem.vue?vue&type=style&index=0&id=30339b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30339b5a",
  null
  
)

export default component.exports